import { IBreadcrumbItem } from '@/types';
import { TEMPLATE_BASE_PATH } from '@/constants';

const BREADCRUMB_ITEMS: IBreadcrumbItem[] = [
  {
    href: '/',
    id: 1,
    label: 'Home',
  },
  {
    href: TEMPLATE_BASE_PATH.SHOP,
    id: 2,
    label: 'Shop',
  },
];

export { BREADCRUMB_ITEMS };
